export default __webpack_public_path__ + "static/media/test-drive-banner-ru.a5cfb2a3.jpg";